export enum InAppReferralLeadStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum InAppReferralTier {
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
}

export const IN_APP_REFERRAL_TIERS: {
  tier: InAppReferralTier;
  minApprovedReferrals: number;
  giftCardCapCents: number;
}[] = [
  {
    tier: InAppReferralTier.BRONZE,
    minApprovedReferrals: 0,
    giftCardCapCents: 100_000,
  },
  {
    tier: InAppReferralTier.SILVER,
    minApprovedReferrals: 5,
    giftCardCapCents: 150_000,
  },
  {
    tier: InAppReferralTier.GOLD,
    minApprovedReferrals: 25,
    giftCardCapCents: 200_000,
  },
  {
    tier: InAppReferralTier.PLATINUM,
    minApprovedReferrals: 50,
    giftCardCapCents: 300_000,
  },
];

export const IN_APP_REFERRAL_CREDIT_CENTS = 100_000;

export interface IInAppReferral {
  referralId: string;
  url: string;
}

export interface IInAppReferralStats {
  tier: InAppReferralTier;
  giftCardCapCents: number;
  approvedThisYear: number;
  nextTier: InAppReferralTier | null;
  approvedNeededForNextTier: number | null;
  totalLeads: number;
  pendingLeads: number;
  approvedLeads: number;
  rejectedLeads: number;
  totalApprovedPayoutCents: number;
  totalPaidPayoutCents: number;
  paidLeads: number;
}

export interface IInAppReferralCompanyResponse {
  referral: IInAppReferral | null;
  stats: IInAppReferralStats;
}

/** `companyName` is the lead's own employer, not the referring company. */
export interface IInAppReferralLead {
  id: string;
  companyId: number;
  referringCompanyName?: string;
  fullName: string;
  companyName: string;
  companyEmail: string;
  phoneNumber: string;
  servicesRequested: string[];
  hasExistingEntity: boolean;
  region: string;
  status: InAppReferralLeadStatus;
  payoutAmountCents: number | null;
  reviewedByUserId: string | null;
  reviewedAt: string | null;
  paidAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface IInAppReferralLeadsResponse {
  items: IInAppReferralLead[];
  count: number;
}

export interface IInAppReferralLeadsSummary {
  totalLeads: number;
  pendingLeads: number;
  approvedLeads: number;
  rejectedLeads: number;
  totalApprovedPayoutCents: number;
  totalPaidPayoutCents: number;
  paidLeads: number;
}

export interface IInAppReferralCompany {
  companyId: number;
  companyDisplayName: string;
  referralId: string;
  url: string;
  tier: InAppReferralTier;
  totalLeads: number;
  approvedLeads: number;
  approvedThisYear: number;
  giftCardCapCents: number;
  createdAt: string;
}

export interface IInAppReferralCompaniesResponse {
  items: IInAppReferralCompany[];
  count: number;
}

export interface IInAppReferralPublicResponse {
  referral: {
    companyName: string;
  };
}
